<mat-card class="crud-search-card">
  <mat-card-title i18n="@@type.AssetType">Asset Type</mat-card-title>
  <mat-card-content>
    <form [formGroup]="searchForm">
      <div class="search-section">

        <mat-form-field matTooltip="Asset Type Id" [matTooltipDisabled]="disabledTooltip(this.assetTypeId)">
          <mat-label i18n="@@type.AssetType.assetTypeId">Asset Type Id</mat-label>
          <input matInput formControlName="assetTypeId" id="assetTypeIdFilterInput"              
              (ngModelChange)="assetTypeIdChanging($event)" [(ngModel)]="assetTypeIdFilter"              
              (ngModelChange)="assetTypeIdChanged($event)" #assetTypeIdFilterInput              
              type="number" placeholder="Asset Type Id">
        </mat-form-field>  

        <mat-form-field matTooltip="Name" [matTooltipDisabled]="disabledTooltip(this.name)">
          <mat-label i18n="@@type.AssetType.name">Name</mat-label>
          <input matInput formControlName="name" id="nameFilterInput"              
              (ngModelChange)="nameChanging($event)" [(ngModel)]="nameFilter"              
              (ngModelChange)="nameChanged($event)" #nameFilterInput              
              maxlength="255" placeholder="Name">
        </mat-form-field>  

        
        <mat-form-field matTooltip="Select a Electrical Aspect Requirement from the list" [matTooltipDisabled]="disabledTooltip(this.electricalAspectRequirement)">
          <mat-label i18n="@@type.AssetType.electricalAspectRequirement">Electrical Aspect</mat-label>
          <mat-select formControlName="electricalAspectRequirement" id="electricalAspectRequirementFilterInput"              
              (ngModelChange)="electricalAspectRequirementChanging($event)" [(ngModel)]="electricalAspectRequirementFilter"              
              (ngModelChange)="electricalAspectRequirementChanged($event)" #electricalAspectRequirementFilterInput              
              placeholder="Electrical Aspect Requirement">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let electricalAspectRequirement of electricalAspectRequirementSelectionList" [value]="electricalAspectRequirement.code">
              {{electricalAspectRequirement.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Select a Mechanical Aspect Requirement from the list" [matTooltipDisabled]="disabledTooltip(this.mechanicalAspectRequirement)">
          <mat-label i18n="@@type.AssetType.mechanicalAspectRequirement">Mechanical Aspect</mat-label>
          <mat-select formControlName="mechanicalAspectRequirement" id="mechanicalAspectRequirementFilterInput"              
              (ngModelChange)="mechanicalAspectRequirementChanging($event)" [(ngModel)]="mechanicalAspectRequirementFilter"              
              (ngModelChange)="mechanicalAspectRequirementChanged($event)" #mechanicalAspectRequirementFilterInput              
              placeholder="Mechanical Aspect Requirement">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let mechanicalAspectRequirement of mechanicalAspectRequirementSelectionList" [value]="mechanicalAspectRequirement.code">
              {{mechanicalAspectRequirement.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Select a Maintenance Aspect Requirement from the list" [matTooltipDisabled]="disabledTooltip(this.maintenanceAspectRequirement)">
          <mat-label i18n="@@type.AssetType.maintenanceAspectRequirement">Maintenance Aspect</mat-label>
          <mat-select formControlName="maintenanceAspectRequirement" id="maintenanceAspectRequirementFilterInput"              
              (ngModelChange)="maintenanceAspectRequirementChanging($event)" [(ngModel)]="maintenanceAspectRequirementFilter"              
              (ngModelChange)="maintenanceAspectRequirementChanged($event)" #maintenanceAspectRequirementFilterInput              
              placeholder="Maintenance Aspect Requirement">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let maintenanceAspectRequirement of maintenanceAspectRequirementSelectionList" [value]="maintenanceAspectRequirement.code">
              {{maintenanceAspectRequirement.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </div>

      <div class="search-section">

		<mat-slide-toggle floatLabel="always" appearance="none" color="primary"  *ngIf="autoSearchControlsEnabled"
          [(ngModel)]="autoSearch"  [ngModelOptions]="{standalone: true}">
            Auto Search
        </mat-slide-toggle>

        <button mat-raised-button color="primary" class="action-button" (click)="forceSearch()" type="button"
          i18n="@@actions.search">Search</button>
		  

        <button mat-raised-button color="primary" class="action-button" (click)="clearFilters()" type="button"
          [disabled]="!allowsClearFilters()" i18n="@@actions.clearFilters">Clear Filters</button>
      </div>
			
    </form>

    <div class="mat-elevation-z8">
      <div class="mat-table-wrapper">
        <mat-table #table [dataSource]="dataSource" matSort
                           matSortDirection="asc" matSortDisableClear cdkDropList cdkDropListLockAxis="x"
                           cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" Group>

          <ng-container matColumnDef="assetTypeId">
            <mat-header-cell [crud-column-header]="columns.column('assetTypeId')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AssetType.assetTypeId">
                Asset Type Id 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.assetTypeId | number:'1.0-2':'en-GB'}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="comments">
            <mat-header-cell [crud-column-header]="columns.column('comments')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AssetType.comments">
                Comments 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.comments}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="createdBy">
            <mat-header-cell [crud-column-header]="columns.column('createdBy')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AssetType.createdBy">
                Created By 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.createdBy}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="createdDate">
            <mat-header-cell [crud-column-header]="columns.column('createdDate')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AssetType.createdDate">
                Created Date 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.createdDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="electricalAspectRequirement">
            <mat-header-cell [crud-column-header]="columns.column('electricalAspectRequirement')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AssetType.electricalAspectRequirement">
                Electrical Aspect 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.electricalAspectRequirement | refDecode:'REQUIREMENT_RULE' | async}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="guidanceText">
            <mat-header-cell [crud-column-header]="columns.column('guidanceText')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AssetType.guidanceText">
                Guidance Text 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.guidanceText}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="havs">
            <mat-header-cell [crud-column-header]="columns.column('havs')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AssetType.havs">
                Havs 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.havs">check_box</mat-icon><mat-icon *ngIf="!element.havs">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="havsRagStatus">
            <mat-header-cell [crud-column-header]="columns.column('havsRagStatus')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AssetType.havsRagStatus">
                Havs Rag Status 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.havsRagStatus | refDecode:'RAG_STATUS' | async}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="maintenanceAspectRequirement">
            <mat-header-cell [crud-column-header]="columns.column('maintenanceAspectRequirement')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AssetType.maintenanceAspectRequirement">
                Maintenance Aspect 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.maintenanceAspectRequirement | refDecode:'REQUIREMENT_RULE' | async}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="maintenanceType">
            <mat-header-cell [crud-column-header]="columns.column('maintenanceType')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AssetType.maintenanceType">
                Maintenance Type 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.maintenanceType}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="mechanicalAspectRequirement">
            <mat-header-cell [crud-column-header]="columns.column('mechanicalAspectRequirement')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AssetType.mechanicalAspectRequirement">
                Mechanical Aspect 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.mechanicalAspectRequirement | refDecode:'REQUIREMENT_RULE' | async}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="name">
            <mat-header-cell [crud-column-header]="columns.column('name')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AssetType.name">
                Name 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.name}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="periodicMaintenance">
            <mat-header-cell [crud-column-header]="columns.column('periodicMaintenance')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AssetType.periodicMaintenance">
                Periodic Maintenance 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.periodicMaintenance">check_box</mat-icon><mat-icon *ngIf="!element.periodicMaintenance">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="periodicMaintenanceDays">
            <mat-header-cell [crud-column-header]="columns.column('periodicMaintenanceDays')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AssetType.periodicMaintenanceDays">
                Periodic Maintenance Days 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.periodicMaintenanceDays | number:'1.0-2':'en-GB'}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="portableApplianceTestingDays">
            <mat-header-cell [crud-column-header]="columns.column('portableApplianceTestingDays')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AssetType.portableApplianceTestingDays">
                Portable Appliance Testing Days 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.portableApplianceTestingDays | number:'1.0-2':'en-GB'}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="routineMaintenance">
            <mat-header-cell [crud-column-header]="columns.column('routineMaintenance')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AssetType.routineMaintenance">
                Routine Maintenance 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.routineMaintenance">check_box</mat-icon><mat-icon *ngIf="!element.routineMaintenance">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="routineMaintenanceDays">
            <mat-header-cell [crud-column-header]="columns.column('routineMaintenanceDays')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AssetType.routineMaintenanceDays">
                Routine Maintenance Days 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.routineMaintenanceDays | number:'1.0-2':'en-GB'}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="updatedBy">
            <mat-header-cell [crud-column-header]="columns.column('updatedBy')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AssetType.updatedBy">
                Updated By 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.updatedBy}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="updatedDate">
            <mat-header-cell [crud-column-header]="columns.column('updatedDate')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AssetType.updatedDate">
                Updated Date 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.updatedDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="visualInspection">
            <mat-header-cell [crud-column-header]="columns.column('visualInspection')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AssetType.visualInspection">
                Visual Inspection 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.visualInspection">check_box</mat-icon><mat-icon *ngIf="!element.visualInspection">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="wbv">
            <mat-header-cell [crud-column-header]="columns.column('wbv')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AssetType.wbv">
                Wbv 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.wbv">check_box</mat-icon><mat-icon *ngIf="!element.wbv">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="wbvRagStatus">
            <mat-header-cell [crud-column-header]="columns.column('wbvRagStatus')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AssetType.wbvRagStatus">
                Wbv Rag Status 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.wbvRagStatus | refDecode:'RAG_STATUS' | async}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="actions" stickyEnd>
            <mat-header-cell class="search-column-actions mat-elevation-z9" *matHeaderCellDef>
              <span i18n="@@common.actions">Actions</span>
              <app-column-picker-dialog-launcher [columns]="columns">
              </app-column-picker-dialog-launcher>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="search-column-actions mat-elevation-z9">
              <button class="action-button" *ngIf="allowsEdit(element)" mat-raised-button color="primary"
                [routerLink]="editRoute(element)" [queryParams]="editRouteQueryParams()" i18n="@@actions.edit" id="actions.edit">Edit</button>
              <button class="action-button" [queryParams]="viewRouteQueryParams()" *ngIf="allowsView(element)" mat-raised-button color="primary"
                [routerLink]="viewRoute(element)" i18n="@@actions.view" id="actions.view">View</button>
              <button class="action-button" *ngIf="allowsDelete(element)" mat-raised-button color="accent"
                (click)="deleteWithConfirmation(element)" i18n="@@actions.delete" id="actions.delete">Delete</button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columns.displayedColumns;" class="search-table"></mat-row>

        </mat-table>
      </div>
      <mat-paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.size" [pageSizeOptions]="pageSizes">
      </mat-paginator>

      <button class="action-button" *ngIf="allowsCreate()" mat-raised-button color="primary" [routerLink]="createRoute()"
        [queryParams]="createRouteQueryParams()" i18n="@@actions.create" id="actions.create">Create</button>
      <button class="action-button" *ngIf="allowsBack()" mat-raised-button color="accent" [routerLink]="backRoute()"
        [queryParams]="backRouteQueryParams()" i18n="@@actions.back" id="actions.back">Back</button>
    </div>
  </mat-card-content>
</mat-card>